/**
 * Provides methods to interact with user-related local storage.
 */

class UserLocalStorage {
  // user id
  id = null;

  // user-related data
  data = {};

  /**
   * Set user id.
   * @param {number|string} id  - user id.
   */
  static setUser(id) {
    this.id = id;
    this.data = JSON.parse(localStorage.getItem(`u${id}`)) ?? {};
  }

  /**
   * Get user-related data by key.
   * @param {string} key - key.
   * @returns {any} value.
   */

  static getData(key) {
    if (!this.id) {
      return null;
    }
    return this.data[key];
  }

  /**
   * Set user-related data by key
   * @param {string} key - key.
   * @param {any} value.
   */

  static setData(key, value) {
    this.data[key] = value;
    this.save();
  }

  /**
   * Save user-related data to local storage.
   */

  static save() {
    localStorage.setItem(`u${this.id}`, JSON.stringify(this.data));
  }
}

export default UserLocalStorage;
